export const franchisePage = {
  seo: {
    title: "紅豆餅加盟｜來加綉綉紅豆餅加盟專區",
    description:
      "想經營紅豆餅副業、擺攤、市集、店面或甜點品牌？來加綉綉紅豆餅加盟專區提供品牌系統、產品口味、開店支援與營運陪跑諮詢。",
  },
  hero: {
    tag: "加盟專區",
    title: "想把紅豆餅，做成一份可以長久經營的小生意？",
    subtitle:
      "紅豆餅看似簡單，但要穩定販售、持續回購、控制成本與建立熟客，需要的不只是技術，而是一套能落地的品牌與營運系統。",
    ctaPrimary: "預約加盟諮詢",
    ctaSecondary: "了解加盟支援",
  },
  targetAudience: {
    sectionTitle: "你適合從來加綉綉開始嗎？",
    cards: [
      {
        label: "副業族",
        title: "想培養第二收入的人",
        desc: "適合想在正職之外，逐步建立可執行、可累積的小型甜點事業。",
      },
      {
        label: "家庭型創業",
        title: "想兼顧家庭與彈性工時的人",
        desc: "紅豆餅相較重餐飲，更有機會依地點、時段與人力規劃彈性經營。",
      },
      {
        label: "品牌型創業",
        title: "想把傳統點心做出新風格的人",
        desc: "紅豆餅可傳統、可文青、可創意，適合打造有記憶點的品牌故事。",
      },
    ],
  },
  value: {
    sectionTitle: "加盟不是只買品牌，而是買一套更快進入市場的系統",
    intro:
      "很多創業新手最難的不是做出一顆紅豆餅，而是做出穩定能賣、能複製、能持續優化的產品與經營模式。加盟的價值，在於協助你縮短摸索期，降低試錯成本，讓產品、設備、流程、行銷與熟客經營更有方向。",
    supports: [
      {
        title: "品牌系統",
        desc: "品牌定位、視覺風格、主打商品結構、銷售話術與顧客體驗設計。",
      },
      {
        title: "開店支援",
        desc: "協助建立攤車、餅模、設備、招牌、動線、備料與供應資源建議。",
      },
      {
        title: "後續陪跑",
        desc: "開幕不是終點，會持續協助檢視產品、價格、曝光、活動與回頭客經營。",
      },
    ],
  },
  process: {
    sectionTitle: "從詢問到開賣，清楚走完每一步",
    steps: [
      {
        step: "STEP 01",
        title: "初步諮詢",
        desc: "了解你的預算、時間、地點、目標與經營型態。",
      },
      {
        step: "STEP 02",
        title: "評估模式",
        desc: "確認適合攤車、市集、店面、雲端接單或複合式經營。",
      },
      {
        step: "STEP 03",
        title: "產品與設備規劃",
        desc: "確認主力口味、設備需求、出餐流程與基本營運配置。",
      },
      {
        step: "STEP 04",
        title: "教育訓練",
        desc: "進行產品製作、內餡搭配、出餐節奏、保存與顧客服務訓練。",
      },
      {
        step: "STEP 05",
        title: "開幕準備",
        desc: "協助菜單、視覺、社群、活動與開幕導流規劃。",
      },
      {
        step: "STEP 06",
        title: "營運陪跑",
        desc: "依實際銷售狀況調整品項、價格、活動與曝光策略。",
      },
    ],
  },
  faq: {
    sectionTitle: "加盟常見問題",
    questions: [
      {
        q: "我完全沒有餐飲經驗，可以加盟嗎？",
        a: "可以先透過諮詢評估。重點不是過去是否做過餐飲，而是是否願意練習、理解流程並面對營運細節。",
      },
      {
        q: "紅豆餅市場競爭很多，還有機會嗎？",
        a: "市場上確實有許多紅豆餅與車輪餅，但關鍵在於產品穩定度、地點、售價、口味記憶點與熟客經營。",
      },
      {
        q: "可以先了解再決定是否加盟嗎？",
        a: "可以。建議先預約諮詢，了解自己的預算、時間與適合模式，再決定是否進一步合作。",
      },
      {
        q: "可以做自己的特色口味嗎？",
        a: "可依品牌規劃與營運模式討論，重點是確保口味具市場接受度，也能穩定製作與販售。",
      },
    ],
  },
  bottomCta: {
    title: "創業最怕的不是辛苦，而是走錯方向。",
    desc: "如果你想知道自己是否適合經營紅豆餅品牌，歡迎先預約一對一諮詢。",
    ctaPrimary: "預約加盟諮詢",
    ctaSecondary: "加入 LINE 詢問",
  },
};